import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

export const getHomeViews = () => {
  try {
    return axios.get(BASE_URL + "home/getHomeViews", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const createHomeView = (payload) => {
  try {
    return axios.post(BASE_URL + "home/createHomeView", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const updateHomeView = (payload) => {
  try {
    return axios.post(BASE_URL + "home/updateHomeView", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const deleteHomeView = (payload) => {
  try {
    return axios.post(BASE_URL + "home/deleteHomeView", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const resetHomeView = (payload) => {
  try {
    return axios.post(BASE_URL + "home/resetHomeView", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getHomeLayout = (viewId) => {
  try {
    return axios.get(BASE_URL + "home/getHomeLayout?view_id=" + viewId, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const saveHomeLayout = (payload) => {
  try {
    return axios.post(BASE_URL + "home/saveHomeLayout", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const saveHomeViewOrder = (payload) => {
  try {
    return axios.post(BASE_URL + "home/saveHomeViewOrder", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

// ── Widget Builder ──

export const getWidgetCollections = () => {
  try {
    return axios.get(BASE_URL + "home/widget-builder/collections", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getWidgetFields = (collection, sampleSize = 50) => {
  try {
    return axios.get(
      BASE_URL +
        "home/widget-builder/fields/" +
        encodeURIComponent(collection) +
        "?sample_size=" +
        sampleSize,
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

// export const widgetBuilderQuery = (config) => {
//   try {
//     return axios.post(BASE_URL + "home/widget-builder/query", config, {
//       headers: authHeader(),
//     });
//   } catch (e) {
//     console.log(e);
//   }
// };

export const widgetBuilderPreview = (config) => {
  try {
    return axios.post(BASE_URL + "home/widget-builder/preview", config, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getWidgetDistinctValues = (collection, field) => {
  try {
    return axios.post(
      BASE_URL + "home/widget-builder/distinct",
      { collection, field },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getDigest = (force = false) => {
  try {
    return axios.get(BASE_URL + "home/digest" + (force ? "?force=true" : ""), {
      headers: authHeader(),
      // Don't parse as JSON — we need raw text for streaming
      responseType: force ? "text" : undefined,
    });
  } catch (e) {
    console.log(e);
  }
};

export const getDigestStream = (force = false) => {
  const token = localStorage.getItem("token");
  return fetch(
    (BASE_URL || "/api/") + "home/digest" + (force ? "?force=true" : ""),
    {
      headers: { "X-Access-Token": token },
    },
  );
};

export const getInbox = () => {
  try {
    return axios.get(BASE_URL + "home/inbox", { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};

export const getNewData = () => {
  try {
    return axios.get(BASE_URL + "home/new-data", { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};

export const getNewsAnchorVideos = () => {
  try {
    return axios.get(BASE_URL + "feed/getNewsAnchorVideoVtt", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const playNewsAnchorVideo = (documentId) => {
  try {
    return axios.get(
      BASE_URL +
        "feed/playNewsAnchorVideoVtt?document_id=" +
        encodeURIComponent(documentId),
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};
